import { api } from '../../config/api'
import {
  HOTELS,
  POPULAR_HOTELS,
  HOTELS_DETAILS
} from '../../actions/actionTypes'

export const getHotels = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().hotels.list[lang].lastUpdate || !getState().hotels.list[lang].data.length) {
    dispatch({ type: HOTELS.REQUEST })
    return (
      fetch(api.hotels+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: HOTELS.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: HOTELS.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularHotels = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().hotels.popular[lang].lastUpdate || !getState().hotels.popular[lang].data.length) {
    dispatch({ type: POPULAR_HOTELS.REQUEST, lang })
    return (
      fetch(api.hotelsPopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_HOTELS.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_HOTELS.FAILURE, error: err })
      })
    )
  }
}

export const getHotelsDataById = (id) => (dispatch, getState) => {
  const { lang, lasted } = getState()
  dispatch({ type: HOTELS_DETAILS.REQUEST })
  return (
    fetch(api.hotels+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: HOTELS_DETAILS.SUCCESS, data: res, lang, lasted })
    })
    .catch((err) => {
      dispatch({ type: HOTELS_DETAILS.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/containers/Hotels/actions.js